module.exports = __webpack_public_path__ + "img/computer-landpage.81b0ffcd.svg";